import ExperimentInstallationPlatforms from "../../../../contents/docs/experiments/installation/_snippets/installation-platforms.tsx";
import * as React from 'react';
export default {
  ExperimentInstallationPlatforms,
  React
};